var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJeuPc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.39 51.54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 10.49 17.64 .04 35.45 13.09 25.72 32.53 4.51 32.38 0 10.49",
    fill: "#f63",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.3,16.29v14.27h-2.96v20.23h10.04v-9.86h9.67v7.91h-5.07v1.68h21.98v-1.68h-5.07v-7.91h16.75v-24.65H14.3ZM32.73,48.84v-7.76h8.48v7.76h-8.48ZM19.71,40.93v8.18h-6.69v-16.88h6.69v8.7ZM57.97,39.26H21.38v-8.7h-5.41v-12.6h41.99v21.29Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.63,51.04h-10.54v-20.73h2.96v-14.27h45.84v25.14h-16.75v7.41h5.07v2.17h-22.48v-2.17h5.07v-7.41h-9.17v9.86ZM11.59,50.54h9.54v-9.86h10.17v8.41h-5.07v1.17h21.48v-1.17h-5.07v-8.41h16.75v-24.14H14.55v14.27h-2.96v19.73ZM19.96,49.36h-7.19v-17.38h7.19v17.38ZM13.27,48.86h6.19v-16.38h-6.19v16.38ZM41.46,49.09h-8.98v-8.26h8.98v8.26ZM32.98,48.59h7.98v-7.26h-7.98v7.26ZM58.22,39.51H21.13v-8.7h-5.41v-13.1h42.49v21.79ZM21.63,39.01h36.08v-20.79H16.22v12.1h5.41v8.7Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.36,33.91c-.13,0-.26.02-.39.04-.95.18-1.67,1.02-1.67,2.02s.72,1.83,1.67,2.02c.13.02.26.04.39.04,1.13,0,2.06-.92,2.06-2.06s-.92-2.06-2.06-2.06ZM16.36,36.35c-.21,0-.38-.17-.38-.38s.17-.38.38-.38.38.17.38.38-.17.38-.38.38Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.16,
    y: 27.59,
    width: 12.99,
    height: 1.68,
    transform: "translate(-8.26 26.76) rotate(-30.67)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,32.81l-1.11-1.87,11.6-6.88,1.11,1.87-11.6,6.88ZM38.99,31.11l.6,1.01,10.74-6.37-.6-1.01-10.74,6.37Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 23.89,
    width: 6.83,
    height: 1.68,
    transform: "translate(-6.77 24.81) rotate(-30.69)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.22,27.54l-1.11-1.87,6.31-3.74,1.11,1.87-6.31,3.74ZM38.79,25.84l.6,1.01,5.45-3.23-.6-1.01-5.45,3.23Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.16,
    y: 31.92,
    width: 6.83,
    height: 1.68,
    transform: "translate(-10.2 28.35) rotate(-30.68)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.98,35.57l-1.11-1.87,6.31-3.74,1.11,1.87-6.31,3.74ZM43.55,33.87l.6,1.01,5.45-3.23-.6-1.01-5.45,3.23Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.64,44.97c-2.27,0-4.12,1.85-4.12,4.12v1.42h8.24v-1.42c0-2.27-1.85-4.12-4.12-4.12ZM52.21,48.84c.13-1.23,1.17-2.19,2.43-2.19s2.31.96,2.43,2.19h-4.86Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.01,50.77h-8.74v-1.67c0-2.41,1.96-4.37,4.37-4.37s4.37,1.96,4.37,4.37v1.67ZM50.77,50.27h7.74v-1.17c0-2.13-1.74-3.87-3.87-3.87s-3.87,1.74-3.87,3.87v1.17ZM57.35,49.09h-5.42l.03-.28c.14-1.38,1.29-2.42,2.68-2.42s2.54,1.04,2.68,2.42l.03.28ZM52.51,48.59h4.27c-.23-.98-1.1-1.69-2.14-1.69s-1.91.71-2.14,1.69Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJeuPc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Jeu PC.17aed66ebd8b80c80f2c2414c60f2116.svg";